<template>
    <div>
        <div class="contents">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="breadcrumb-main user-member justify-content-sm-between ">
                            <div class=" d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                                <div
                                    class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                    <router-link to="/contact" class="btn btn-sm btn-outline-secondary mr-3" title="Kembali ke Data Kontak">
                                        <i class="fas fa-arrow-left"></i> Kembali
                                    </router-link>
                                    <h4 class="text-capitalize fw-500 breadcrumb-title mb-0">Edit Kontak</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <div v-if="!isLoading" class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                            <form v-on:submit.prevent="updateContact">
                                <label> Nama </label>
                                <input type="text" class="form-control" v-model="form.name">
                                <br>
                                <label> Nomor Whatsapp </label>
                                <input type="text" class="form-control" placeholder="08xxxxxxxx" v-model="form.number">
                                <br>
                                <label> Tanggal Ulang Tahun </label>
                                <input type="date" class="form-control" v-model="form.birth_date">
                                <br>
                                <label> 🏷️ Label Kontak </label>
                                <div class="label-select-box">
                                    <span v-for="l in availableLabels" :key="l.id"
                                        class="label-chip"
                                        :style="{ background: selectedLabelIds.includes(l.id) ? l.color : '#e9ecef', color: selectedLabelIds.includes(l.id) ? labelTextColor(l.color) : '#666' }"
                                        @click="toggleLabel(l.id)">
                                        <i v-if="selectedLabelIds.includes(l.id)" class="fas fa-check"></i> {{ l.name }}
                                    </span>
                                    <span v-if="availableLabels.length === 0" class="text-muted small">
                                        Belum ada label. Buat dulu di menu <router-link to="/contact-labels">Label Kontak</router-link>.
                                    </span>
                                    <span v-else class="text-muted small d-block mt-1">
                                        Kelola/tambah label di <router-link to="/contact-labels">Label Kontak</router-link> (sidebar Data, di bawah Data Kontak).
                                    </span>
                                </div>
                                <br>
                                <a v-on:click="addVariable" class="btn btn-success text-white"
                                    style="display: inline-flex; margin: 5px">
                                    Tambah Variabel
                                </a>
                                <a v-on:click="deleteVariable" class="btn btn-danger text-white"
                                    style="display: inline-flex; margin: 5px">
                                    Hapus Variabel
                                </a>
                                <div class="form-group mb-20">
                                    <br>
                                    <div id="var">
                                        <div v-for="(vars, index) in form.variable" v-bind:key="index">
                                            <label for="">Variabel {{ vars.id }}</label>
                                            <input class="form-control" type="text" v-model="vars.value" required />
                                            <br />
                                        </div>
                                    </div>
                                </div>
                                <div class="button-group d-flex pt-25">
                                    <button type="submit"
                                        class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block">
                                        simpan
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div v-else class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                            <center>
                                <div class="spinner-border spinner" role="status"></div>
                            </center>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div v-if="!isLoading" class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                            <center>
                                <h3>Group</h3>
                            </center>
                            <br>
                            <vue-good-table ref="group-table" :columns="g.columns" :rows="g.rows"
                                :select-options="{ enabled: true }">
                            </vue-good-table>
                            <br>
                            <button v-on:click="saveGroup" class="btn btn-primary text-white btn-block">Simpan</button>
                        </div>
                        <div v-else class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                            <center>
                                <div class="spinner-border spinner" role="status"></div>
                            </center>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                group_id: '',
                form: {
                    id: "",
                    name: "",
                    number: "",
                    birth_date: "",
                    variable: [],
                    group: null,
                },
                joined_group: [],
                availableLabels: [],
                selectedLabelIds: [],
                g: {
                    columns: [{
                        label: "Group",
                        field: "name",
                    }],
                    rows: []
                },
                group: [],
                isLoading: true,
            };
        },
        mounted() {
            this.loadData()
            this.group_id = this.$route.query.id
            this.loadLabels()
        },
        methods: {
            labelTextColor(hex) {
                if (!hex || typeof hex !== 'string') return '#fff';
                const h = hex.replace('#', '').trim();
                if (h.length < 6) return '#fff';
                const r = parseInt(h.substr(0, 2), 16);
                const g = parseInt(h.substr(2, 2), 16);
                const b = parseInt(h.substr(4, 2), 16);
                const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
                return lum > 0.6 ? '#222' : '#fff';
            },
            async loadLabels() {
                try {
                    const r = await this.$store.dispatch("contact_labels_list")
                    this.availableLabels = r.data.data.labels || []
                    const id = this.$route.query.id
                    if (id) {
                        const r2 = await this.$store.dispatch("contact_get_labels", id)
                        this.selectedLabelIds = r2.data.data.label_ids || []
                    }
                } catch (e) { /* silent */ }
            },
            toggleLabel(id) {
                const i = this.selectedLabelIds.indexOf(id)
                if (i === -1) this.selectedLabelIds.push(id)
                else this.selectedLabelIds.splice(i, 1)
            },
            parseContactData(data) {
                if (!data) return []
                
                try {
                    // Try to parse as JSON first
                    if (data.startsWith('{') || data.startsWith('[')) {
                        return JSON.parse(data)
                    }
                    
                    // Handle PHP serialized data
                    if (data.startsWith('a:')) {
                        return this.parsePhpSerializedData(data)
                    }
                    
                    // If it's a simple string, return empty array
                    return []
                } catch (e) {
                    console.warn('Failed to parse contact data:', e)
                    return []
                }
            },
            
            parsePhpSerializedData(serializedData) {
                try {
                    // Simple PHP serialized array parser for the specific format
                    // a:3:{s:9:"total_var";s:1:"2";s:4:"var1";s:3:"Ibu";s:4:"var2";N;}
                    const variables = []
                    
                    // Extract total_var to know how many variables we have
                    const totalVarMatch = serializedData.match(/s:9:"total_var";s:\d+:"(\d+)"/)
                    const totalVar = totalVarMatch ? parseInt(totalVarMatch[1]) : 0
                    
                    // Extract each variable
                    for (let i = 1; i <= totalVar; i++) {
                        const varMatch = serializedData.match(new RegExp(`s:4:"var${i}";s:(\\d+):"([^"]*)"`))
                        if (varMatch) {
                            variables.push({
                                id: i,
                                value: varMatch[2]
                            })
                        } else {
                            // Check if it's null
                            const nullMatch = serializedData.match(new RegExp(`s:4:"var${i}";N`))
                            if (nullMatch) {
                                variables.push({
                                    id: i,
                                    value: ""
                                })
                            }
                        }
                    }
                    
                    return variables
                } catch (e) {
                    console.warn('Failed to parse PHP serialized data:', e)
                    return []
                }
            },
            
            async loadData() {
                try {
                    let id = this.$route.query.id
                    let detail = await this.$store.dispatch("contact_detail", id)
                    let group = await this.$store.dispatch("group_list_dropdown")

                    let contactDetail = detail.data.data.contact
                    this.form.id = contactDetail.id 
                    this.form.name = contactDetail.name
                    this.form.number = contactDetail.number 
                    this.form.birth_date = this.formatBirthDate(contactDetail.birth_date)
                    
                    // Parse PHP serialized data or JSON data
                    this.form.variable = this.parseContactData(contactDetail.data)
                    this.joined_group = detail.data.data.joined_group

                    this.g.rows = group.data.data.groups
                    this.preselectedGroup()
                    this.isLoading = false
                } catch (err) {
                    // Handle different error structures
                    let errorMessage = "Terjadi kesalahan saat memuat data"
                    if (err.response && err.response.data && err.response.data.message) {
                        errorMessage = err.response.data.message
                    } else if (err.message) {
                        errorMessage = err.message
                    }
                    this.$toast.error(errorMessage)
                    this.$router.push("/contact")
                }
            },
            formatBirthDate(dateValue) {
                if (!dateValue) {
                    return ""
                }

                const trimmed = String(dateValue).trim()

                // Already in correct format (YYYY-MM-DD)
                if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
                    return trimmed
                }

                // Handle formats like YYYY-MM-DD HH:MM:SS or ISO strings
                const isoMatch = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/)
                if (isoMatch) {
                    return `${isoMatch[1]}-${isoMatch[2]}-${isoMatch[3]}`
                }

                // Handle YYYY/MM/DD
                const isoSlashMatch = trimmed.match(/^(\d{4})\/(\d{2})\/(\d{2})/)
                if (isoSlashMatch) {
                    return `${isoSlashMatch[1]}-${isoSlashMatch[2]}-${isoSlashMatch[3]}`
                }

                // Handle DD-MM-YYYY or DD/MM/YYYY or MM-DD-YYYY / MM/DD/YYYY
                const commonMatch = trimmed.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
                if (commonMatch) {
                    const first = parseInt(commonMatch[1], 10)
                    const second = parseInt(commonMatch[2], 10)

                    // If the first part is > 12, assume DD-MM-YYYY; otherwise assume MM-DD-YYYY
                    if (first > 12) {
                        const day = String(first).padStart(2, '0')
                        const month = String(second).padStart(2, '0')
                        return `${commonMatch[3]}-${month}-${day}`
                    } else if (second > 12) {
                        // second > 12 means MM-DD-YYYY
                        const month = String(first).padStart(2, '0')
                        const day = String(second).padStart(2, '0')
                        return `${commonMatch[3]}-${month}-${day}`
                    } else {
                        // Ambiguous (both ≤ 12); default to DD-MM-YYYY (more common in ID)
                        const day = String(first).padStart(2, '0')
                        const month = String(second).padStart(2, '0')
                        return `${commonMatch[3]}-${month}-${day}`
                    }
                }

                // Handle Unix timestamp (seconds or milliseconds)
                if (/^\d+$/.test(trimmed)) {
                    let timestamp = parseInt(trimmed, 10)
                    if (trimmed.length === 10) {
                        timestamp *= 1000
                    }
                    const date = new Date(timestamp)
                    if (!isNaN(date.getTime())) {
                        const year = date.getFullYear()
                        const month = String(date.getMonth() + 1).padStart(2, '0')
                        const day = String(date.getDate()).padStart(2, '0')
                        return `${year}-${month}-${day}`
                    }
                }

                return ""
            },
            addVariable() {
                this.form.variable.push({
                    id: this.form.variable.length + 1,
                    value: ""
                })
            },
            deleteVariable() {
                this.form.variable.splice(-1)
            },
            preselectedGroup() {
                for (let i = 0; i < this.g.rows.length; i++) {
                    for (let j = 0; j < this.joined_group.length; j++) {
                        if (this.g.rows[i].id == this.joined_group[j].group_id) {
                            this.$set(this.g.rows[i], 'vgtSelected', true)
                            break
                        }
                    }
                }
            },
            setPayloadGroup() {
                let payload = {
                    contact_id: this.$route.query.id,
                    add: [],
                    remove: []
                }

                let selected = this.$refs['group-table'].selectedRows
                let old = this.joined_group

                //ADD
                for (let i = 0; i < selected.length; i++) {
                    let status = false

                    for (let j = 0; j < old.length; j++) {
                        if (old[j].group_id == selected[i].id && status == false) {
                            status = true
                        }
                    }

                    if (status == false) {
                        payload.add.push({
                            id: selected[i].id
                        })
                    }
                }

                //REMOVE
                for (let i = 0; i < old.length; i++) {
                    let status = true
                    for (let j = 0; j < selected.length; j++) {
                        if (selected[j].id == old[i].group_id && status == true) {
                            status = false
                        }
                    }

                    if (status) {
                        payload.remove.push({
                            id: old[i].group_id
                        })
                    }
                }

                return payload
            },
            async updateContact() {
                try {
                    let response = await this.$store.dispatch('contact_update', this.form)
                    // simpan label kontak
                    try {
                        await this.$store.dispatch('contact_set_labels', { id: this.form.id, label_ids: this.selectedLabelIds })
                    } catch (e) { /* silent */ }
                    this.$toast.success(response.data.message);
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
            },
            async saveGroup() {
                let payload = await this.setPayloadGroup()

                try {
                    let response = await this.$store.dispatch('group_update_by_contact', payload)
                    this.$toast.success(response.data.message);
                    this.loadData()
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
            },
        },
    };
</script>

<style scoped>
.label-select-box {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 8px;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    background: #fafbfc;
    min-height: 44px;
    align-items: center;
}
.label-chip {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 14px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    user-select: none;
    transition: all .15s;
}
.label-chip:hover { opacity: .85; transform: translateY(-1px); }
</style>